/**
 * GTINInfoModal - Modal informativo para formato de Excel de GTINs
 */
import React from 'react';
import { Info, X } from 'lucide-react';

interface GTINInfoModalProps {
  onClose: () => void;
}

export const GTINInfoModal: React.FC<GTINInfoModalProps> = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-2xl w-full">
        {/* Header */}
        <div className="bg-gradient-to-r from-purple-600 to-indigo-600 px-6 py-4 rounded-t-xl flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <Info className="text-white" size={24} />
            <h3 className="text-lg font-semibold text-white">
              Formato do Excel - Importar GTINs
            </h3>
          </div>
          <button
            onClick={onClose}
            className="text-white hover:bg-white/20 rounded-lg p-1 transition"
          >
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="bg-purple-50 dark:bg-purple-900/20 border-l-4 border-purple-500 p-4 rounded mb-4">
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-2">
              📋 Colunas do Excel (2 colunas)
            </h3>
            <p className="text-sm text-gray-700 dark:text-gray-300 mb-3">
              O arquivo Excel deve conter as seguintes colunas no cabeçalho (linha 1):
            </p>

            <div className="grid grid-cols-1 gap-2">
              <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-2 list-inside">
                <li><strong>codigo</strong> <span className="text-red-500">*</span> - Código do produto</li>
                <li><strong>gtin</strong> <span className="text-red-500">*</span> - Código GTIN/EAN do produto</li>
              </ul>
            </div>
          </div>

          <div className="bg-amber-50 dark:bg-amber-900/20 border-l-4 border-amber-500 p-4 rounded mb-4">
            <p className="text-sm text-amber-800 dark:text-amber-300">
              <strong>⚠️ Atenção:</strong> A importação <strong>sobrescreve</strong> GTINs existentes com o mesmo código.
              Os dados do Excel substituirão os dados atuais.
            </p>
          </div>

          <div className="text-xs text-gray-500 dark:text-gray-400 border-t border-gray-200 dark:border-gray-700 pt-4">
            <p>💡 <strong>Dica:</strong> O código do produto deve corresponder a um produto já cadastrado para este cliente.</p>
            <p className="mt-1"><span className="text-red-500">*</span> Campo obrigatório.</p>
          </div>

          {/* Footer */}
          <div className="mt-6 flex justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 rounded-lg transition"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
